import { useMemo } from 'react';
import { AnySchema, InferType } from 'yup';

export const useYupSync = <TSchema extends AnySchema>(
  data: any,
  schema: TSchema
): { data?: InferType<TSchema>; error?: any } =>
  useMemo(() => {
    try {
      if (data == null) {
        return {};
      }

      return { data: schema.validateSync(data) };
    } catch (error) {
      return { error };
    }
  }, [data, schema]);
